import Fetch, { V3 } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE } from '@config/constanta';

/**
 * @param {string} paymentReff
 */


export const postAutoOrder = (payload) => {
  const resourceUrl = `${V3}mutualfund/auto-order`;
  return Fetch.post(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
}

export const editAutoOrder = (payload) => {
  const resourceUrl = `${V3}mutualfund/auto-order`;
  return Fetch.put(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
}

/**
 * @param {string} id The auto order mf 
 */

 export const delMfAutoOrder = (query) => {
  const resourceUrl = `${V3}mutualfund/auto-order/${query}`;
  return Fetch.delete(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
}
